import React, { useEffect, useState } from "react";
import adminPricingService from "./adminPricingService";
import SubscriptionCard from "./SubscriptionCard";
import SubscriptionFormModal from "./SubscriptionFormModal";
import AddFeatureModal from "./AddFeatureModal";
import AddPackageModal from "./AddPackage"; // ✅ New import

const SubscriptionManager = () => {
  const [packages, setPackages] = useState([]);
  const [features, setFeatures] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showSubModal, setShowSubModal] = useState(false);
  const [showFeatureModal, setShowFeatureModal] = useState(false);
  const [showAddBasicModal, setShowAddBasicModal] = useState(false); // ✅ New state
  const [editingPackage, setEditingPackage] = useState(null);

  const fetchPackages = async () => {
    try {
      setLoading(true);
      const res = await adminPricingService.getPackages();
      setPackages(res.data || []);
    } catch (error) {
      console.error("Error fetching packages:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchFeatures = async () => {
    try {
      const res = await adminPricingService.getFeatures(1, 100);
      setFeatures(res.data || []);
    } catch (error) {
      console.error("Error fetching features:", error);
    }
  };

  useEffect(() => {
    fetchPackages();
    fetchFeatures();
  }, []);

  const handleEdit = (pkg) => {
    setEditingPackage(pkg);
    setShowSubModal(true);
  };

  const handleAddPackage = () => {
    setEditingPackage(null);
    setShowSubModal(true);
  };

  const handleAddBasicPackage = () => {
    setShowAddBasicModal(true);
  };

  return (
    <div className="p-6">
      <div className="flex flex-wrap justify-between items-center gap-2 mb-6">
        <h1 className="text-2xl font-bold">Subscription Packages</h1>
        <div className="flex gap-2 flex-wrap">
          <button
            onClick={() => setShowFeatureModal(true)}
            className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
          >
            + Add Feature
          </button>
          <button
            onClick={handleAddBasicPackage}
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
          >
            + Add Package
          </button>
        </div>
      </div>

      {loading ? (
        <p>Loading packages...</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {packages.map((pkg) => (
            <SubscriptionCard
              key={pkg.id}
              pkg={pkg}
              featuresList={features}
              onEdit={() => handleEdit(pkg)}
            />
          ))}
        </div>
      )}

      {showSubModal && (
        <SubscriptionFormModal
          initialData={editingPackage}
          onClose={() => setShowSubModal(false)}
          onSuccess={fetchPackages}
        />
      )}

      {showAddBasicModal && (
        <AddPackageModal
          onClose={() => setShowAddBasicModal(false)}
          onSuccess={fetchPackages}
        />
      )}

      {showFeatureModal && (
        <AddFeatureModal
          onClose={() => setShowFeatureModal(false)}
          onSuccess={fetchFeatures}
        />
      )}
    </div>
  );
};

export default SubscriptionManager;
